import React from "react";
import { Link } from 'react-router-dom';
import { MdBookmark as DefaultIcon } from "react-icons/md";

export default ({ url='/', Icon=DefaultIcon, label='', hidden=false }) => {

  if (!!hidden) return null;

  return (
    <Link className='Nav-Link' to={url}>
      <Icon className="Nav-Link-Icon"/>
      <div className="Button">{label}</div>
    </Link>
  );

};
